// extracted by mini-css-extract-plugin
module.exports = {"color__bar":"ColorCard_color__bar__mOdf8","copy":"ColorCard_copy__KykJV","clipboard":"ColorCard_clipboard__2rbZQ","description":"ColorCard_description__2mqGm"};